import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import Btn from '../../../../../../UI/Btn'

import http from '../../../../../../shared/http'
import { TApi } from '../../../../../../shared/const'
import { openParentalTemplate } from '../../../../../../shared/parentalTemplate'

import styles from '../../style.module.scss'

/*
 * „Vorlagen für Ihre Schüler:innen" im Profil der Lehrkraft (Anforderung #182).
 *
 * Lehrkräfte meldeten sich bei JAA, weil sie die Einverständniserklärung für
 * ihre Schüler:innen nicht fanden — der Download lag nur im Profil der
 * Schüler:innen. Hier steht er je betreuter Junior Company: dieselbe Vorlage
 * und derselbe Knopf („Formular download"), nur ohne Namen, weil die beiden
 * Zeilen jede Schüler:in selbst ausfüllt. Eigene Dokumente hat eine Lehrkraft
 * nicht — deshalb gibt es hier auch keinen Hinweis auf Fehlendes.
 */
export default function StudentTemplates() {
	const { t } = useTranslation()
	const [companies, setCompanies] = useState(null)
	const [failed, setFailed] = useState(false)
	const [loadingId, setLoadingId] = useState(null)

	useEffect(() => {
		let aktiv = true

		http.get(TApi.TEACHER_GET_ASSIGNED_COMPANIES, {
			params: { limit: 100, offset: 0, order: 'name', direction: 'asc' },
			disableToast: true
		})
			.then(({ data }) => {
				if (aktiv) setCompanies(data?.supervisedCompanies || [])
			})
			.catch(() => {
				if (aktiv) setFailed(true)
			})

		return () => {
			aktiv = false
		}
	}, [])

	const download = id => {
		setLoadingId(id)
		openParentalTemplate(TApi.TEACHER_PARENTAL_CONFIRMATION_TEMPLATE(id)).finally(() => setLoadingId(null))
	}

	return (
		<section className={styles.section} aria-labelledby="student-templates-title">
			<h1 id="student-templates-title" className={styles.sectionTitle}>
				{t('Templates for your students')}
			</h1>
			<div className={styles.sectionContent}>
				<p className={styles.templatesIntro}>
					{t(
						'Every student needs the consent form signed by a parent or guardian. Download the template for each Junior Company here — your students also find it in their own profile under „Documents“.'
					)}
				</p>

				{failed && <p className={styles.templatesNote}>{t('The Junior Companies could not be loaded.')}</p>}

				{companies && !companies.length && (
					<p className={styles.templatesNote}>
						{t(
							'As soon as you supervise a Junior Company, you will find the consent form template for its students here.'
						)}
					</p>
				)}

				{!!companies?.length && (
					<ul className={styles.templatesList}>
						{companies.map(company => (
							<li key={company.id} className={styles.templatesRow}>
								<div className={styles.templatesName}>
									<span className={styles.templatesDoc}>{t('Consent of parent or guardian')}</span>
									<span className={styles.templatesCompany}>
										{company.name}
										{company.companyType ? ` · ${company.companyType}` : ''}
									</span>
								</div>
								<Btn
									loading={loadingId === company.id}
									className={styles.templatesBtn}
									icon="download"
									iconSize={{ w: 16, h: 16 }}
									iconColor="#fff"
									onClick={() => download(company.id)}
								>
									{t('Download template')}
								</Btn>
							</li>
						))}
					</ul>
				)}
			</div>
		</section>
	)
}
